import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { AddrawmaterialComponent } from 'src/app/components/rawmaterial/addrawmaterial/addrawmaterial.component';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-addadjdetail',
  templateUrl: './addadjdetail.component.html',
  styleUrls: ['./addadjdetail.component.css']
})
export class AddadjdetailComponent implements OnInit {

  
  @ViewChild('Selecter', { static: false }) ngselect: NgSelectComponent;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  isload: boolean = true;

  israwmaterialaddmode: boolean = false;

  rtnform: string = "";
  errtxt: any = "";


  adjBO: any = {}


  ismanualclose: boolean;

  isaccountaddmode: boolean = false;

  discounttype: string = "";

  productfindColl: any;
  taxColl: any;
  rawmaterialColl: any;
  isLoadingResult: boolean;

  filterpaymentmodeid: number = 0;

  adjform = new FormGroup({
    adjdetailsid: new FormControl(0),
    adjid: new FormControl(0),
    rawmaterialid: new FormControl(null, Validators.required),
    rawmaterialname: new FormControl(null),
    qty: new FormControl(null, Validators.required),
    unitprice: new FormControl(null, Validators.required),
    subtotal: new FormControl(null),
    uomid: new FormControl(null, Validators.required),
    taxid: new FormControl(null, Validators.required),
    taxname: new FormControl(null),
    taxrate: new FormControl(null),
    taxamt: new FormControl(null),
    cgsttaxrate: new FormControl(null),
    cgsttaxamt: new FormControl(null),
    sgsttaxrate: new FormControl(null),
    sgsttaxamt: new FormControl(null),
    igsttaxrate: new FormControl(null),
    igsttaxamt: new FormControl(null),
    taxable: new FormControl(null),
    nettotal: new FormControl(null),
    inactive: new FormControl(null),
  });


  formname: String = "Adjustment";



  @Input() adjdetailsid: number = 0
  @Input() adjid: number = 0

  @Input() adjdetailsBO: any = {};

  @Output() emitData = new EventEmitter();

  constructor(private appService: DhukanDataService, private activeModal: NgbActiveModal, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private datePipe: DatePipe) {

    this.fnServiceChanges();
  }


  fnServiceChanges() {

  }

  ngOnInit() {
    try {
      this.fnOnInitForm();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.adjform.reset();
      this.fnInitializeForm();

      this.fnGetRawmaterial();
      this.fnGetTax();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {
    //  this.loginService.fnSetFirstControlFocusLookup(this.ngselect);


  }



  fnInitializeForm() {
    this.adjform.setValue({
      adjdetailsid: this.adjdetailsBO.adjdetailsid,
      adjid: this.adjdetailsBO.adjid,
      rawmaterialid: this.adjdetailsBO.rawmaterialid,
      rawmaterialname: this.adjdetailsBO.rawmaterialname,
      qty: this.adjdetailsBO.qty,
      unitprice: this.adjdetailsBO.unitprice,
      subtotal: this.adjdetailsBO.subtotal,
      uomid: this.adjdetailsBO.uomid,
      taxid: this.adjdetailsBO.taxid,
      taxname: this.adjdetailsBO.taxname,
      taxrate: this.adjdetailsBO.taxrate,
      taxamt: this.adjdetailsBO.taxamt,
      cgsttaxrate: this.adjdetailsBO.cgsttaxrate,
      cgsttaxamt: this.adjdetailsBO.cgsttaxamt,
      sgsttaxrate: this.adjdetailsBO.sgsttaxrate,
      sgsttaxamt: this.adjdetailsBO.sgsttaxamt,
      igsttaxrate: this.adjdetailsBO.igsttaxrate,
      igsttaxamt: this.adjdetailsBO.igsttaxamt,
      taxable: this.adjdetailsBO.taxable,
      nettotal: this.adjdetailsBO.nettotal,
      inactive: false,
    })
  }




  fnValidation() {
    var _ischeck = false;
    var _detailscheck = false;
    var qty = this.adjform.get('qty').value;
    if (this.loginService.fnCheckZeroDetcimal(qty) === 0) {
      this.errtxt = "Quantity is cannot be empty"
      this.adjform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }


    // for (let row of this.purchasedetailscoll) {
    //   if (row.rawmaterialid > 0) {
    //     _detailscheck = true;
    //   }
    // }

    // if (!_detailscheck) {
    //   this.errtxt = "Purchase Details cannot be empty"
    //   this.adjform.controls['inactive'].setErrors({ 'notfound': true });
    //   _ischeck = true;
    // }
    // if (!_ischeck) {
    //   for (let row of this.purchasedetailscoll) {

    //     if (row.rawmaterialid > 0 && this.loginService.fnCheckZeroDetcimal(row.qty) === 0) {
    //       this.errtxt = "Quantity is cannot be empty"
    //       this.adjform.controls['inactive'].setErrors({ 'notfound': true });
    //       _ischeck = true;
    //     }

    //   }
    // }
    return _ischeck;

  }

  fnResetValidation() {

    if (this.adjform.get('inactive')) {
      this.adjform.controls['inactive'].setErrors(null);
    }

  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate

      if (this.adjform.valid) {

        if (this.fnValidation()) {

          return false
        }


        this.saveloading = true;



        //Check
        var data = {
          adjdetailsid: this.adjform.get('adjdetailsid').value,
          adjid: this.adjform.get('adjid').value,
          rawmaterialid: this.adjform.get('rawmaterialid').value,
          rawmaterialname: this.adjform.get('rawmaterialname').value,
          qty: this.adjform.get('qty').value,
          unitprice: this.adjform.get('unitprice').value,
          subtotal: this.adjform.get('subtotal').value,
          uomid: this.adjform.get('uomid').value,
          taxid: this.adjform.get('taxid').value,
          taxname: this.adjform.get('taxname').value,
          taxrate: this.adjform.get('taxrate').value,
          taxamt: this.adjform.get('taxamt').value,
          cgsttaxrate: this.adjform.get('cgsttaxrate').value,
          cgsttaxamt: this.adjform.get('cgsttaxamt').value,
          sgsttaxrate: this.adjform.get('sgsttaxrate').value,
          sgsttaxamt: this.adjform.get('sgsttaxamt').value,
          igsttaxrate: this.adjform.get('igsttaxrate').value,
          igsttaxamt: this.adjform.get('igsttaxamt').value,
          taxable: this.adjform.get('taxable').value,
          nettotal: this.adjform.get('nettotal').value,
        }

        var result = {
          'checkstatus': 'DONE',
          'data': data
        }

        this.emitData.emit(result);
        this.activeModal.close(true);



      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }

  }




  //Close
  async fnCloseForm() {

    try {


      var result = {
        'checkstatus': 'CANCEL',
        'data': null
      }

      this.emitData.emit(result);
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  //Details

  fnGetRawmaterial() {
    this.isLoadingResult = true;

    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.rawmaterialColl = res.json().result;

          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnReLoadRawmaterial() {


    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.fnChangeRawmaterial()
        }, (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnGetTax() {
    this.isLoadingResult = true;

    var data = {
      'taxid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getTax(data)
      .subscribe(
        (res) => {
          this.taxColl = res.json().result;


          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnCalcDetails() {

    var row = {
      adjdetailsid: this.adjform.get('adjdetailsid').value,
      adjid: this.adjform.get('adjid').value,
      rawmaterialid: this.adjform.get('rawmaterialid').value,
      rawmaterialname: this.adjform.get('rawmaterialname').value,
      qty: this.adjform.get('qty').value,
      unitprice: this.adjform.get('unitprice').value,
      subtotal: this.adjform.get('subtotal').value,
      uomid: this.adjform.get('uomid').value,
      taxid: this.adjform.get('taxid').value,
      taxname: this.adjform.get('taxname').value,
      taxrate: this.adjform.get('taxrate').value,
      taxamt: this.adjform.get('taxamt').value,
      cgsttaxrate: this.adjform.get('cgsttaxrate').value,
      cgsttaxamt: this.adjform.get('cgsttaxamt').value,
      sgsttaxrate: this.adjform.get('sgsttaxrate').value,
      sgsttaxamt: this.adjform.get('sgsttaxamt').value,
      igsttaxrate: this.adjform.get('igsttaxrate').value,
      igsttaxamt: this.adjform.get('igsttaxamt').value,
      taxable: this.adjform.get('taxable').value,
      nettotal: this.adjform.get('nettotal').value,
    }

    this.adjdetailsBO.subtotal = row.qty * row.unitprice;

    this.adjform.patchValue({ 'subtotal': this.adjdetailsBO.subtotal });
    //this.subtotal = this.subtotal + Number(row.subtotal)


    this.adjdetailsBO.taxamt = Number(this.fnConvertDecimal(this.adjdetailsBO.subtotal)) * Number(this.fnConvertDecimal(row.taxrate)) / 100
    this.adjform.patchValue({ 'taxamt': this.adjdetailsBO.taxamt });

    //GST      
    this.adjdetailsBO.cgsttaxamt = Number(this.fnConvertDecimal(this.adjdetailsBO.taxamt)) / 2
    this.adjdetailsBO.sgsttaxamt = Number(this.fnConvertDecimal(this.adjdetailsBO.taxamt)) / 2
    this.adjdetailsBO.igsttaxamt = 0

    this.adjform.patchValue({
      'cgsttaxamt': this.adjdetailsBO.cgsttaxamt,
      'sgsttaxamt': this.adjdetailsBO.sgsttaxamt,
      'igsttaxamt': this.adjdetailsBO.igsttaxamt
    })

    this.adjdetailsBO.taxable = Number(this.fnConvertDecimal(this.adjdetailsBO.subtotal));
    this.adjform.patchValue({ 'taxable': this.adjdetailsBO.taxable });

    this.adjdetailsBO.nettotal = Number(this.fnConvertDecimal(this.adjdetailsBO.taxable)) + Number(this.fnConvertDecimal(this.adjdetailsBO.taxamt))
    this.adjform.patchValue({ 'nettotal': this.adjdetailsBO.nettotal });
  }




  fnChangeRawmaterial() {

    var row = {
      rawmaterialid: this.adjform.get('rawmaterialid').value,
    }

    var _prodname = "", _uomid = null, _unitprice = 0, _taxid = null;

    for (let abo of this.rawmaterialColl) {
      if (row.rawmaterialid === abo.rawmaterialid) {
        _prodname = abo.rawmaterialname;
        _unitprice = abo.purchaseprice;
        _uomid = abo.purchaseuomid;
        _taxid = abo.taxid;
      }
    }
    this.adjdetailsBO.rawmaterialname = _prodname;
    this.adjdetailsBO.unitprice = _unitprice;
    this.adjdetailsBO.uomid = _uomid;
    this.adjdetailsBO.taxid = _taxid;

    this.adjform.patchValue({ 'rawmaterialname': this.adjdetailsBO.rawmaterialname });
    this.adjform.patchValue({ 'unitprice': this.adjdetailsBO.unitprice });
    this.adjform.patchValue({ 'uomid': this.adjdetailsBO.uomid });
    this.adjform.patchValue({ 'taxid': this.adjdetailsBO.taxid });

    this.fnChangeTax()
  }


  fnChangeTax() {


    var row = {
      taxid: this.adjform.get('taxid').value,
    }



    var _taxname = "", _taxrate = 0;

    var _cgsttaxrate = 0, _sgsttaxrate = 0, _igsttaxrate = 0;

    for (let abo of this.taxColl) {
      if (row.taxid === abo.taxid) {
        _taxname = abo.taxname;
        _taxrate = abo.taxrate;
        _cgsttaxrate = abo.cgsttaxrate;
        _sgsttaxrate = abo.sgsttaxrate;
        _igsttaxrate = abo.igsttaxrate;
      }
    }
    this.adjdetailsBO.taxname = _taxname;
    this.adjdetailsBO.taxrate = _taxrate;
    this.adjdetailsBO.cgsttaxrate = _cgsttaxrate;
    this.adjdetailsBO.sgsttaxrate = _sgsttaxrate;
    this.adjdetailsBO.igsttaxrate = _igsttaxrate;

    this.adjform.patchValue({ 'taxname': this.adjdetailsBO.taxname });
    this.adjform.patchValue({ 'taxrate': this.adjdetailsBO.taxrate });
    this.adjform.patchValue({ 'cgsttaxrate': this.adjdetailsBO.cgsttaxrate });
    this.adjform.patchValue({ 'sgsttaxrate': this.adjdetailsBO.sgsttaxrate });
    this.adjform.patchValue({ 'igsttaxrate': this.adjdetailsBO.igsttaxrate });


    this.fnCalcDetails()

  }



  //AddProduct
  private fnAddRawmaterial(index) {

    const modalRef = this.productFindService.open(AddrawmaterialComponent, { size: <any>'xxl' });
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetRawmaterial();

      if (receivedEntry > 0) {
        this.adjdetailsBO.rawmaterialid = receivedEntry
      }
      this.fnReLoadRawmaterial();

    });
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnConvertDecimal(value) {
    if (!value) {
      return 0
    }
    else {
      return value
    }

  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}
